module.exports = __webpack_public_path__ + "img/Croatia.5b66a258.png";